import React from "react";
import useMixin from "../hooks/useMixin";
import { isLoading } from "../Loading";
import { AppState } from "../system/AppState";
import analyticsUtils from "../utils/analyticsUtils";

interface Props {
  appState: AppState;
}

export default function LogRocketAnalyics(props: Props) {
  const { appCaregiverState } = useMixin(props.appState);

  React.useEffect(() => {
    if (isLoading(appCaregiverState) || !appCaregiverState.caregiver.isCaregiverOfMedFlyt) {
      return;
    }

    analyticsUtils.initAndIdentifyCaregiver({ caregiver: appCaregiverState.caregiver });
  }, [appCaregiverState]);

  return <></>;
}
